import { rem } from 'polished';
import * as s from 'styled-components';
import * as react from 'react';
const styled = s.default;

export const HighlightedLink: any = styled.a`
  color: ${(props: any) => props.color || props.theme.colors.textPrimary};
  font-weight: ${(props: any) => (props.bold ? '700' : '400')};
  text-decoration: underline;
  transition: opacity 0.2s ease;

  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
`;

export const Spacer: any = styled.span`
  margin-left: ${(props: any) => rem(props.spaceWidth)};
`;

export const Strong: any = styled.span`
  font-weight: ${(props: any) => props.fontWeight};
`;

export const Icon: any = styled.img`
  width: 100%;
  height: 100%;
`;

export const Dividor: any = styled.div`
  margin-bottom: ${(props: any) => rem(props.size)};
  width: 100%;
`;

export const MainContainer: any = styled.div`
  width: ${({ theme }) => theme.mainContainerSize || '1170px'};
  margin: 0 auto;
  padding: 0 15px;
  min-height: ${(props: any) => props.minHeight || '100px'};

  @media all and (max-width: ${({ theme }) =>
      theme.mainContainerSize || '1170px'}) {
    width: 100%;
    margin: 0;
  }
`;
